<div id="company-comments">
    <h2 class="m-b-5" mat-dialog-title>{{commentData.companyName}}</h2>
    <div mat-dialog-content>
        <div >
            <p>{{commentData.comment}}</p>
        </div>
    </div>
    <div class="text-a-r  m-t-10 m-b-10">
        <button mat-raised-button (click)="cancel()" color="warn">Cerrar</button>
    </div>
</div>